import app from "@/main";

function doesContainCode() {
  const containsAuthCode = window.location.href.split("?code=");
  if (containsAuthCode[1]) {
    return true;
  }
  return false;
}

function doesHaveAccessToken() {
  const rkflAccess = app.prototype.$DbStorage.getItem("rocketfuel_access");
  if (rkflAccess) {
    return true;
  }
  return false;
}

function doesHaveParentOpener() {
  // eslint-disable-next-line no-unneeded-ternary
  return window.opener ? true : false;
}

export default function auth({ next, store }) {
  // For Safari fix
  if (doesHaveParentOpener() && !doesHaveAccessToken() && doesContainCode()) {
    window.opener.location.href = window.location.href;
    window.close();
  }
  if (store.getters["auth/isAuth"] && !store.getters["auth/userStatus"]) {
    return next({
      name: "EmailConfirm",
    });
  }
  if (!store.getters["auth/isAuth"] && !store.getters["auth/userStatus"] && !window.location.pathname.includes('hostedPage')) {
    return next({
      name: "Welcome",
    });
  }
  return next();
}
